import React from 'react';
import { TabView, TabPanel } from 'primereact/tabview';

/**
 * StudentDetailsSection Component
 * 
 * Renders the main student profile tabs with content:
 * - Personal tab (personal information)
 * - Contact tab (contact details)
 * - Academic tab (academic information)
 * - Other tab (other details)
 * 
 * Each tab displays its content using render functions passed as props
 */
export const StudentDetailsSection = ({ 
    activeIndex,
    onTabChange,
    renderPersonalTab,
    renderContactTab,
    renderAcademicTab,
    renderOtherTab
}) => {
    return (
        <div className="student-content">
            <TabView
                activeIndex={activeIndex}
                onTabChange={onTabChange}
                className="student-tabs"
            >
                <TabPanel
                    header="Personal"
                    leftIcon="pi pi-user"
                >
                    {renderPersonalTab()}
                </TabPanel>
                <TabPanel
                    header="Contact"
                    leftIcon="pi pi-phone"
                >
                    {renderContactTab()}
                </TabPanel>
                <TabPanel
                    header="Academic"
                    leftIcon="fa fa-graduation-cap"
                >
                    {renderAcademicTab()}
                </TabPanel>
                <TabPanel
                    header="Other"
                    leftIcon="pi pi-file"
                >
                    {renderOtherTab()}
                </TabPanel>
            </TabView>
        </div>
    );
};

export default StudentDetailsSection;
